import Description from "../../components/common/Description";
import { AssociateKycUserDesc } from "../../components/common/json-data/AssociateKycUserDesc";
import Grid from "@mui/material/Grid";
import ApiTest from "../../components/common/ApiTest";
import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import MiniDrawer from "../../components/navBar/Sidenav";
import { Box } from "@mui/material";
import { AssociateKycUserApiData } from "../../components/common/constants";

function AssociateKycUser() {
  return (
    <div style={{ display: "flex" }}>
      <MiniDrawer />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Description bodyDesc={AssociateKycUserDesc[0]} />
          </Grid>
          <Grid item xs={6}>
            <ApiTest apidata={AssociateKycUserApiData} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default AssociateKycUser;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
